/** Auto-generated from Simplified Chinese. Do not edit by hand.
 *  Regenerate: node scripts/generate-zh-hant.js
 */
export const zhHantPack = {
  selector: {
    selectorTrigger: "獲取專屬打印方案",
    selectorFabTeaserTitle: "👋 不知道選哪款打印機？",
    selectorFabTeaserSubtitle: "30分鐘內獲取專屬推薦",
    selectorTitle: "不知道該選擇哪款打印機？",
    selectorSubtitle: "填寫您的需求，我們將在30分鐘內為您推薦最適合的設備方案。",
    selectorProductLabel: "您想打印什麼產品？",
    selectorProductPlaceholder: "請輸入產品類型",
    selectorProductHint: "例如：手機殼、保溫杯、亞克力、玻璃、金屬、行李箱、標籤貼紙、服裝",
    selectorSizeLabel: "您的產品尺寸？",
    selectorSizePlaceholder: "請輸入產品尺寸",
    selectorSizeHint: "例如：20×30cm、A3、A2、直徑80mm、500×700mm",
    selectorOutputLabel: "預計日產量？",
    selectorOutput1: "1－50件",
    selectorOutput2: "50－200件",
    selectorOutput3: "200－500件",
    selectorOutput4: "500－1000件",
    selectorOutput5: "1000件以上",
    selectorBudgetLabel: "預算範圍？",
    selectorBudget1: "2萬元以內",
    selectorBudget2: "2萬－5萬元",
    selectorBudget3: "5萬－10萬元",
    selectorBudget4: "10萬元以上",
    selectorBudget5: "暫未確定",
    selectorSelectPlaceholder: "請選擇",
    selectorSubmit: "獲取推薦方案",
    selectorSubmitting: "提交中…",
    selectorSubmitError: "提交失敗，請稍後重試或直接聯繫我們。",
    selectorSuccessTitle: "感謝提交需求！",
    selectorSuccessDesc: "我們的顧問將在30分鐘內聯繫您，並提供：",
    selectorSuccessItem1: "推薦機型",
    selectorSuccessItem2: "配置建議",
    selectorSuccessItem3: "樣品案例",
    selectorSuccessItem4: "運費估算",
    selectorSuccessItem5: "報價方案",
    selectorClose: "關閉"
  },
  budget: {
    selectorBudget1: "2萬元以內",
    selectorBudget2: "2萬－5萬元",
    selectorBudget3: "5萬－10萬元",
    selectorBudget4: "10萬元以上"
  },
  contact: {
    selectorContactSection: "聯繫方式",
    selectorPhoneLabel: "電話",
    selectorPhonePlaceholder: "請輸入手機號碼",
    selectorWechatLabel: "微信",
    selectorWechatPlaceholder: "請輸入微信號（選填）",
    selectorRequired: "必填",
    selectorOptional: "選填"
  },
  emailLead: {
    emailLeadTitle: "獲取免費打印創業資料包",
    emailLeadDesc: "留下郵箱領取：",
    emailLeadItem1: "產品目錄",
    emailLeadItem2: "視頻案例",
    emailLeadItem3: "成本利潤分析",
    emailLeadItem4: "設備選型指南",
    emailLeadPlaceholder: "請輸入您的郵箱",
    emailLeadSubmit: "立即獲取",
    emailLeadSubmitting: "提交中…",
    emailLeadSubmitError: "提交失敗，請稍後重試。",
    emailLeadClose: "關閉",
    emailLeadSuccessTitle: "提交成功！",
    emailLeadSuccessDesc: "資料包將發送至您的郵箱，請注意查收。"
  },
  footer: {
    footerTagline: "工業打印解決方案供應商",
    footerReach: "服務172個國家客戶",
    footerProductsTitle: "產品中心",
    footerProductUv: "UV打印機",
    footerProductUvDtf: "UV DTF打印機",
    footerProductCylinder: "圓柱體打印機",
    footerProductDtf: "DTF打印機",
    footerProductDtg: "DTG打印機",
    footerApplicationsTitle: "應用場景",
    footerAppPhoneCase: "手機殼",
    footerAppThermos: "保溫杯",
    footerAppAcrylic: "亞克力",
    footerAppGlass: "玻璃",
    footerAppMetal: "金屬",
    footerAppLuggage: "行李箱",
    footerContactTitle: "聯繫我們",
    footerWhatsapp: "WhatsApp",
    footerWhatsappTang: "唐先生：+86 17748697567",
    footerWhatsappSun: "孫先生：+86 15361896795",
    footerWhatsappSunDtfDtg: "孫先生：+86 17796314755",
    footerEmail: "Email",
    footerAddress: "華南公司地址",
    footerAddressValue: "中國廣東省深圳市寶安區西鄉街道易捷通新零售數字化產業園A座5層",
    footerAddressEast: "華東公司地址",
    footerAddressEastValue: "上海市松江區滬松公路1658號九潤科技創新園區A棟",
    footerAddressVietnam: "越南公司地址",
    footerAddressVietnamValue: "102 Phạm Văn Sừng, Xuân Thới Thượng, Hóc Môn, Thành phố Hồ Chí Minh",
    footerEmailSales: "銷售",
    footerEmailSupport: "技術支持",
    footerEmailExport: "海外業務",
    footerFactoryTour: "工廠參觀",
    footerFactoryTourValue: "預約參觀深圳生產基地",
    footerCatalogueDownload: "目錄下載",
    footerCatalogueDownloadValue: "索取最新產品目錄 PDF",
    footerCtaCatalogue: "獲取產品目錄",
    footerCtaFactory: "參觀工廠",
    footerCtaDistributor: "成為經銷商",
    footerSocialTitle: "掃碼關注獲取更多最新訊息",
    footerSocialFacebook: "Facebook",
    footerSocialYoutube: "YouTube",
    footerSocialXiaohongshu: "小紅書",
    footerSocialDouyin: "抖音",
    footerSocialSaveHint: "長按二維碼可保存圖片",
    footerSocialSaveAria: "長按保存二維碼"
  },
  about: {
    aboutHeroLine1: "23年專注數字打印設備研發製造",
    aboutHeroLine2: "服務172個國家和地區",
    aboutHeroLine3: "年設備交付能力 53,000+",
    aboutHeroLine4: "支持OEM / ODM定製服務",
    aboutHeroCtaSolution: "獲取專屬方案",
    aboutHeroCtaFactory: "預約參觀工廠",
    aboutHeroStatClients: "215,000+",
    aboutHeroStatDelivered: "53,000+",
    aboutHeroStatCountries: "172+",
    aboutHeroStatYears: "23年",
    aboutHeroStatClientsLabel: "合作客戶",
    aboutHeroStatDeliveredLabel: "年設備交付能力",
    aboutHeroStatCountriesLabel: "服務國家",
    aboutHeroStatYearsLabel: "行業經驗",
    aboutHeroTagSgs: "SGS認證工廠",
    aboutHeroTagCe: "CE認證",
    aboutHeroTagFcc: "FCC認證",
    aboutHeroTagRohs: "ROHS認證",
    aboutHeroTagOem: "OEM/ODM",
    aboutHeroTagSupport: "24H技術支持",
    aboutHeroImageAlt: "詠遠數字打印設備生產車間",
    aboutHeroFactoryBadgeTitle: "YONGYUAN FACTORY",
    aboutHeroFactoryBadgeCapacity: "53,000+ Units / Year",
    aboutHeroFactoryBadgeClients: "215,000+ Customers Served",
    aboutCompanyStatCountriesPrefix: "服務",
    aboutCompanyStatCountries: "172",
    aboutCompanyStatCountriesLabel: "個國家和地區",
    aboutCompanyRnd1Title: "研發實驗室",
    aboutCompanyRnd1Subtitle: "Industrial R&D Center",
    aboutCompanyRnd1Alt: "詠遠科技研發實驗室",
    aboutCompanyRnd2Title: "工程測試",
    aboutCompanyRnd2Subtitle: "Quality Inspection Center",
    aboutCompanyRnd2Alt: "詠遠科技工程測試中心",
    aboutCompanyBreadcrumb: "首頁 / 關於詠遠",
    aboutCompanyTitle: "公司簡介",
    aboutCompanySubtitle: "專注數字打印設備研發、製造、銷售與全球服務",
    aboutCompanyP1: "詠遠科技成立於2003年，是一家專注數字打印解決方案的國家高新技術企業，集研發、製造、銷售與服務於一體。",
    aboutCompanyP2: "公司位於深圳，在上海、安徽及越南設有分支機構，持續為全球客戶提供專業、高效的數字打印設備及應用解決方案。",
    aboutCompanyP3: "經過23年的持續發展，詠遠科技累計服務超過215,000家客戶，業務覆蓋全球172個國家和地區，年設備交付能力超過53,000臺，支持OEM / ODM定製合作。",
    aboutCompanyP4: "詠遠科技建立了獨有的6S服務體系，覆蓋售前諮詢、方案推薦、安裝指導、技術培訓、售後工程支持及長期運營陪伴，持續為客戶創造長期價值。",
    aboutCultureTitle: "企業文化",
    aboutCultureSubtitle: "以客戶價值為核心，以技術創新為驅動，持續打造可靠產品與專業服務。",
    aboutCultureValue1Title: "客戶第一",
    aboutCultureValue1Text: "以客戶需求為出發點，持續提供適合客戶業務發展的打印解決方案。",
    aboutCultureValue2Title: "創新驅動",
    aboutCultureValue2Text: "持續投入產品研發與工藝優化，提升設備穩定性、效率與應用範圍。",
    aboutCultureValue3Title: "長期服務",
    aboutCultureValue3Text: "通過6S服務體系，為客戶提供\n售前諮詢、安裝培訓、售後支持與長期陪伴。",
    aboutCultureValue4Title: "結果導向",
    aboutCultureValue4Text: "堅持用結果檢驗服務價值，幫助客戶實現更穩定的生產與商業增長。",
    aboutCultureImage1Alt: "詠遠科技企業文化牆",
    aboutCultureImage1Caption: "企業文化牆",
    aboutCultureImage1Subtitle: "Corporate Culture Wall",
    aboutCultureImage2Alt: "詠遠科技團隊服務現場",
    aboutCultureImage2Caption: "團隊服務現場",
    aboutCultureImage2Subtitle: "Team Service Site",
    aboutGlobalTitle: "全球客戶網絡",
    aboutGlobalStatCountriesValue: "172",
    aboutGlobalStatCountriesLabel: "服務國家與地區",
    aboutGlobalStatClientsValue: "215,000+",
    aboutGlobalStatClientsLabel: "合作客戶",
    aboutGlobalStatCapacityValue: "53,000+",
    aboutGlobalStatCapacityLabel: "年設備交付能力",
    aboutGlobalRegionAmerica: "美洲",
    aboutGlobalRegionEurope: "歐洲",
    aboutGlobalRegionMiddleEast: "中東",
    aboutGlobalRegionAsiaPacific: "亞太",
    aboutGlobalRegionSouthAmerica: "南美",
    aboutGlobalRegionsAria: "全球服務區域",
    aboutHonorsTitle: "資質榮譽",
    aboutHonorsSubtitle: "持續通過多項質量與安全體系認證，夯實企業綜合競爭力。",
    aboutHonorCe: "CE",
    aboutHonorCeAlt: "CE 認證證書",
    aboutHonorCeAlt2: "CE 符合性認證證書",
    aboutHonorSgs: "SGS",
    aboutHonorSgsAlt: "SGS 驗廠認證報告",
    aboutHonorQir: "質檢報告",
    aboutHonorQirAlt: "UV 打印機檢測報告",
    aboutHonorFcc: "FCC",
    aboutHonorFccAlt: "FCC 符合性聲明證書",
    aboutHonorStatPatentsValue: "20+",
    aboutHonorStatPatentsLabel: "項專利",
    aboutHonorStatCertificationsValue: "10+",
    aboutHonorStatCertificationsLabel: "項國際認證"
  },
  customerStory: {
    customerStoryCountryUsaNewYork: "美國紐約",
    customerStoryCountryGermany: "德國",
    customerStoryCountryThailand: "泰國",
    customerStoryCountrySpain: "西班牙",
    customerStoryCountryBrazil: "巴西",
    customerStoryCountryAustralia: "澳洲",
    customerStoryCountrySaudiArabia: "沙特",
    customerStoryCountrySingapore: "新加坡",
    customerStoryCountryKorea: "韓國",
    customerStoryCountryIsrael: "以色列",
    customerStoryCountryKazakhstan: "哈薩克斯坦",
    customerStoryCountryMexico: "墨西哥",
    customerStoryCountryArgentina: "阿根廷",
    customerStoryCountryPhilippines: "菲律賓",
    customerStoryCountryIndonesia: "印尼",
    customerStoryCountryNetherlands: "荷蘭",
    customerStoryCountrySweden: "瑞典",
    customerStoryCountrySouthAfrica: "南非",
    customerStoryCountryMalaysia: "馬來西亞",
    customerStoryCountryTaiwan: "中國臺灣",
    customerStoryCountryUsa: "美國",
    customerStoryCaption01: "美國｜6090 UV Printer",
    customerStoryCaption02: "德國｜F33 DTF Printer",
    customerStoryCaption03: "泰國｜3250 UV Printer",
    customerStoryCaption04: "西班牙｜3250 UV Printer",
    customerStoryCaption05: "巴西｜2030 UV Printer",
    customerStoryCaption06: "澳洲｜F33 DTF Printer",
    customerStoryCaption07: "沙特｜2030 UV Printer",
    customerStoryCaption08: "新加坡｜F33 DTF Printer",
    customerStoryCaption09: "韓國｜F33 DTF Printer",
    customerStoryCaption10: "以色列｜UVC33 DTF Printer",
    customerStoryCaption11: "哈薩克斯坦｜4030 UV Printer",
    customerStoryCaption12: "墨西哥｜4060 UV Printer",
    customerStoryCaption13: "阿根廷｜4060 UV Printer",
    customerStoryCaption14: "菲律賓｜6090 UV Printer",
    customerStoryCaption15: "印尼｜4030 UV Printer",
    customerStoryCaption16: "荷蘭｜4030 UV Printer",
    customerStoryCaption17: "瑞典｜4060 UV Printer",
    customerStoryCaption18: "德國｜2030 UV Printer",
    customerStoryCaption19: "南非｜2030 UV Printer",
    customerStoryCaption20: "馬來西亞｜F33 DTF Printer",
    customerStoryCaption21: "中國臺灣｜UVC33 DTF Printer",
    customerStoryCaption22: "美國｜F70Pro DTF Printer",
    customerStoryCaption23: "美國｜2513 UV Printer",
    customerStoryCaption24: "美國｜6090 UV Printer",
    customerStoryCaption25: "美國｜4030 UV Printer",
    customerStoryCaption26: "美國｜3250 UV Printer",
    customerStoryCaption27: "韓國｜4060 UV Printer",
    customerStoryCaption28: "荷蘭｜4060 UV Printer",
    customerStoryCountryCambodia: "柬埔寨",
    customerStoryCountryCanada: "加拿大",
    customerStoryCaption29: "柬埔寨｜4030 UV Printer",
    customerStoryCaption30: "加拿大｜F33 DTF Printer",
  },
  cases: {
    casesHeroTitle: "應用場景",
    casesHeroLead: "適用於多種材質與定製場景，滿足個性化定製、小批量生產與工業應用需求",
    casesEquipmentTitle: "設備類型",
    casesSceneTitleUv: "UV平板打印機可以打印哪些產品？",
    casesSceneTitleCylinder: "圓柱體打印機可以打印哪些產品？",
    casesSceneTitleCrystal: "水晶標打印機可以打印哪些產品？",
    casesSceneTitleDtf: "DTF打印機可以打印哪些產品？",
    casesSceneTitleDtg: "DTG打印機可以打印哪些產品？",
    casesCtaTitle: "發現新的打印生意機會",
    casesCtaDesc: "告訴我們您想打印的產品，我們將為您匹配適合的數字打印方案。",
    casesCtaButton: "獲取打印方案",
    casesEmpty: "暫無該設備的應用場景",
    casesIndustryNav: "行業分類",
    backToTop: "回到頂部",
    casesDetailTitle: "打印效果",
    casesVariantsIntro: "可打印多種類型",
    casesVariantsMore: "等等",
    casesVariantsHint: "告訴我們您要打印的產品材質與數量，獲取專屬打印方案。",
    casesCardTagline: "個性化定製",
    casesCardPitch: "高精度彩色打印",
    casesPrintEffect: "打印效果",
    casesAppVideo: "應用視頻",
    casesVideoPlaceholder: "視頻即將上線",
    scenePhoneCase: "手機殼",
    sceneAcrylic: "亞克力",
    sceneGlass: "玻璃",
    sceneWood: "木板",
    scenePvc: "PVC板",
    sceneAbs: "ABS",
    sceneLeather: "皮革",
    sceneMetal: "金屬",
    sceneGiftBox: "禮盒",
    sceneLuggage: "行李箱",
    sceneSignage: "標牌",
    sceneStone: "石材",
    sceneThermos: "保溫杯",
    sceneMug: "馬克杯",
    sceneGlassCup: "玻璃杯",
    sceneWineBottle: "酒瓶",
    scenePerfume: "香水瓶",
    sceneCosmetic: "化妝品瓶",
    sceneWaterBottle: "礦泉水瓶",
    sceneSportBottle: "運動水壺",
    sceneVacuumPot: "保溫壺",
    sceneMilkTea: "奶茶杯",
    sceneHelmet: "頭盔",
    scenePackBox: "包裝盒",
    sceneCeramic: "陶瓷",
    sceneTshirt: "T恤",
    sceneHoodie: "衛衣",
    sceneCap: "帽子",
    sceneJeans: "牛仔褲",
    sceneTote: "帆布袋",
    sceneShoes: "鞋子",
    sceneKidsWear: "童裝",
    sceneWorkWear: "工服",
    sceneSportWear: "運動服",
    scenePillow: "抱枕",
    sceneDenim: "牛仔布",
    sceneCanvas: "帆布",
    sceneCotton: "棉布",
    scenePolo: "POLO衫",
    sceneEcoBag: "環保袋",
    casesDetailClose: "關閉"
  },
  hero: {
    heroBanner1Title: "SGS認證 實力工廠",
    heroBanner1MetricPrefix: "年產量",
    heroBanner1MetricSuffix: "臺",
    heroBanner1Feature1: "機器出口172個國家",
    heroBanner1Feature2: "支持OEM/ODM代工",
    heroBanner1Feature3: "6S服務 行業獨有",
    heroBanner1Feature4: "支持各種方案定製",
  },
  uiChrome: {
    uiClose: "關閉",
    carouselPrev: "上一個產品",
    carouselNext: "下一個產品",
    heroSlidePrev: "上一張",
    heroSlideNext: "下一張",
    heroSlideDot: "切換到第{n}張"
  }
};
